// extracted by mini-css-extract-plugin
export var currencyInput = "_mq-1";
export var currencySymbol = "_mq-0";